<template>
  <div>
    <Head title="湖南省小额贷款公司经营数据填报系统" />
    <portal-target name="dropdown" slim />
    <div class="md:flex md:flex-col">
      <div class="md:flex md:flex-col md:h-screen">
        <div class="md:flex md:flex-shrink-0" style="height: 64px;">
          <div
            class="md:text-md flex items-center justify-between p-4 w-full text-lg bg-white border-b md:px-8 md:py-0"
          >
            <div class="flex items-center justify-between">
              <Link :href="zroute('app.dashboard')"><i class="bi-grid-3x3-gap-fill hover:bg-gray-200" /></Link>
              <div class="ml-2">小贷公司经营数据填报系统</div>
            </div>
            <div class="justify-between">
              <el-tooltip v-if="auth.user.is_admin" class="item" effect="dark" content="通讯录" placement="bottom">
                <Link class="mr-2 text-sm sc-hqyNC sc-hhaNoI cnJQNK" :href="zroute('contacts.index')"><i class="icon icon-business"></i>组织管理</Link>
              </el-tooltip>
              <dropdown class="mt-1" placement="bottom-end">
                <template #default>
                  <div class="group flex items-center cursor-pointer select-none">
                    <div class="mr-1 text-gray-700 group-hover:text-indigo-600 focus:text-indigo-600 whitespace-nowrap">
                      <span>{{ auth.user.nickname }}</span>
                    </div>
                    <icon
                      class="w-5 h-5 fill-gray-700 group-hover:fill-indigo-600 focus:fill-indigo-600"
                      name="cheveron-down"
                    />
                  </div>
                </template>
                <template #dropdown>
                  <div class="mt-2 py-2 text-sm bg-white rounded shadow-xl">
                    <Link
                        href="/password"
                      class="block px-6 py-2 w-full text-left hover:text-white hover:bg-indigo-500"
                    >
                      修改密码
                    </Link>
                    <Link
                      v-if="auth.user.role === 'company'"
                      href="/info"
                      class="block px-6 py-2 w-full text-left hover:text-white hover:bg-indigo-500"
                    >
                      修改资料
                    </Link>
                    <Link
                      class="block px-6 py-2 w-full text-left hover:text-white hover:bg-indigo-500" href="/logout"
                      method="delete" as="button"
                    >
                      退出登录
                    </Link>
                  </div>
                </template>
              </dropdown>
            </div>
          </div>
        </div>
        <div class="md:flex md:flex-grow md:overflow-hidden">
          <div class="w-full">
            <el-container class="h-full">
              <el-aside class="bg-gray-100" width="250px" style="height: 100%;">
                <app-menu :auth="auth" active-index="1" />
              </el-aside>
              <el-main class="m-0 p-0 bg-white">
                <slot />
              </el-main>
            </el-container>
          </div>
        </div>
      </div>
    </div>
    <loan-amount-confirm v-if="!auth.user.isnew && auth.user.role === 'company'" :company="auth.user.company"></loan-amount-confirm>
  </div>
</template>

<script>
import {Head, Link} from '@inertiajs/inertia-vue'
import Icon from '@/Shared/Icon'
import Dropdown from '@/Shared/Dropdown'
import AppMenu from '../components/AppMenu'
import LoanAmountConfirm from '../components/LoanAmountConfirm'

export default {
  components: {
    LoanAmountConfirm,
    Dropdown,
    Icon,
    Link,
    Head,
    AppMenu
  },
  props: {
    auth: Object,
  },
}
</script>
<style scoped>
.cnJQNK {
  align-items: center;
  cursor: pointer;
  height: 32px;
  line-height: 32px;
  padding: 0 12px 0 14px;
  border-radius: 32px;
  border: 1px solid #eaeaea;
  color: #333;
  margin: 0px 10px 0px 20px;
}
</style>
